import React, { useEffect, useState, useCallback } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { removeCookieAsync } from "../../utils";
import { Helmet } from "react-helmet-async";
import PartnerContainer from "./PartnerContainer";
import Loading from "../Loading";
import axios from "axios";
import { endpoint } from "../../config";
import { useSelector } from "react-redux";

export default function PartnerLayout() {

  const [isValidating, setIsValidating] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const location = useLocation();
  const { partnerToken } = useSelector((state) => state.token);

  const validateToken = useCallback(async () => {
    if (!partnerToken) {
      setIsValidating(false);
      setIsTokenValid(false);
      return;
    }

    try {
      setIsValidating(true);
      await axios.get(`${endpoint}/api/partner-reverify`);
      setIsTokenValid(true);
    } catch (error) {
      console.error('Token validation failed:', error);
      setIsTokenValid(false);
      await removeCookieAsync("p_atkn");
    } finally {
      setIsValidating(false);
    }
  }, [partnerToken]);

  useEffect(() => {
    validateToken();
  }, [location.pathname, validateToken]);

  useEffect(() => {
    if (partnerToken) {
      validateToken();
    } else {
      setIsValidating(false);
    }
  }, [partnerToken, validateToken]);

  if (isValidating) {
    return <Loading />;
  }

  if (!partnerToken || !isTokenValid) {
    return <Navigate to="/partner/login" />;
  }

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
        <style>
          {`
					body {
						font-family: 'Roboto', sans-serif !important;
					}
					`}
        </style>
      </Helmet>
      <PartnerContainer>
        <Outlet />
      </PartnerContainer>
    </>
  );
}
